import {generateUUID} from "../../../gd/utils/id/uuid";

/**
 * The secret a new webhook starts with. It is generated here, on the client —
 * the server takes whatever `secret` it is given on create/update and only
 * falls back to generating one of its own when the key is left out entirely.
 *
 * Hex only (no dashes): the value is pasted into third-party configs by hand,
 * so it has to survive being read out loud and typed back in.
 */
export default function generateWebhookSecret(): string {
    return generateUUID().replace(/-/g, '')
}
